// Input validation utilities for SOC2 compliance

const MAX_LENGTHS = {
  name: 200,
  address: 500,
  city: 100,
  state: 50,
  zip: 20,
  phone: 200,
  gate_code: 50,
  access_notes: 2000,
  unit_number: 50,
  special_notes: 5000,
  task_description: 1000,
};

export const sanitizeString = (str, maxLength = 1000) => {
  if (typeof str !== 'string') return '';
  return str.trim().slice(0, maxLength);
};

export const validateProperty = (data) => {
  const errors = {};

  if (!data.name?.trim()) {
    errors.name = 'Property name is required';
  } else if (data.name.length > MAX_LENGTHS.name) {
    errors.name = `Property name must be ${MAX_LENGTHS.name} characters or less`;
  }

  if (!data.address?.trim()) {
    errors.address = 'Address is required';
  } else if (data.address.length > MAX_LENGTHS.address) {
    errors.address = `Address must be ${MAX_LENGTHS.address} characters or less`;
  }

  if (data.city && data.city.length > MAX_LENGTHS.city) {
    errors.city = `City must be ${MAX_LENGTHS.city} characters or less`;
  }

  if (data.state && data.state.length > MAX_LENGTHS.state) {
    errors.state = `State must be ${MAX_LENGTHS.state} characters or less`;
  }

  if (data.zip && data.zip.length > MAX_LENGTHS.zip) {
    errors.zip = `ZIP must be ${MAX_LENGTHS.zip} characters or less`;
  }

  if (data.property_manager_name && data.property_manager_name.length > MAX_LENGTHS.phone) {
    errors.property_manager_name = `Property manager info must be ${MAX_LENGTHS.phone} characters or less`;
  }

  if (data.property_manager_phone && data.property_manager_phone.length > MAX_LENGTHS.phone) {
    errors.property_manager_phone = `Maintenance supervisor info must be ${MAX_LENGTHS.phone} characters or less`;
  }

  if (data.gate_code && data.gate_code.length > MAX_LENGTHS.gate_code) {
    errors.gate_code = `Gate code must be ${MAX_LENGTHS.gate_code} characters or less`;
  }

  if (data.access_notes && data.access_notes.length > MAX_LENGTHS.access_notes) {
    errors.access_notes = `Access notes must be ${MAX_LENGTHS.access_notes} characters or less`;
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateJob = (data) => {
  const errors = {};

  if (!data.property_id) {
    errors.property_id = 'Property is required';
  }

  if (!data.scheduled_date) {
    errors.scheduled_date = 'Scheduled date is required';
  } else if (!/^\d{4}-\d{2}-\d{2}$/.test(data.scheduled_date)) {
    errors.scheduled_date = 'Invalid date format';
  }

  if (data.deadline_date && !/^\d{4}-\d{2}-\d{2}$/.test(data.deadline_date)) {
    errors.deadline_date = 'Invalid date format';
  }

  if (data.unit_number && data.unit_number.length > MAX_LENGTHS.unit_number) {
    errors.unit_number = `Unit number must be ${MAX_LENGTHS.unit_number} characters or less`;
  }

  if (data.special_notes && data.special_notes.length > MAX_LENGTHS.special_notes) {
    errors.special_notes = `Special notes must be ${MAX_LENGTHS.special_notes} characters or less`;
  }

  const validUrgencyFlags = ['normal', 'high', 'critical'];
  if (data.urgency_flag && !validUrgencyFlags.includes(data.urgency_flag)) {
    errors.urgency_flag = 'Invalid urgency level';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateTask = (description) => {
  if (!description?.trim()) {
    return { isValid: false, error: 'Task description is required' };
  }
  if (description.length > MAX_LENGTHS.task_description) {
    return { isValid: false, error: `Task must be ${MAX_LENGTHS.task_description} characters or less` };
  }
  return { isValid: true, error: null };
};

export const validateDateParam = (date) => {
  if (!date) return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const parsed = new Date(date + 'T00:00:00');
  return !isNaN(parsed.getTime());
};
